import React, { useEffect, useMemo, useState } from "react";
import "./topicslist.css";
import { ChevronRight, Sparkles, Zap, Loader2 } from "lucide-react";
import { miscService } from "../service/misc.service";
import { apiConstants } from "../constants/apiurl.constant";

const TredingTopics = () => {
  const [topicList, setTopicList] = useState([]);
  const [paused, setPaused] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getAllTrendingTopics();
  }, []);

  const getAllTrendingTopics = async () => {
    try {
      setIsLoading(true);
      const response = await miscService.getTrendingTopics();

      if (response?.data) {
        setTopicList(response.data);
        console.log("Trending topics response:", response.data);
        
      }
    } catch (err) {
      console.log(err, "this is error message");
    } finally {
      setIsLoading(false);
    }
  };

  // Double the array once to create loop effect
   const fullList = useMemo(() => {
    if (topicList.length === 0) return [];
    
    // Triple the array for smoother infinite scroll
    return [...topicList, ...topicList, ...topicList];
  }, [topicList]);

  
  // Calculate animation duration based on number of items
  const animationDuration = useMemo(() => {
    // Base duration of 8 seconds per set of original items
    return `${topicList.length * 8}s`;
  }, [topicList.length]);

  // Skeleton Component
  const TopicSkeleton = () => (
    <div className="topic-item skeleton">
      <div>
        <div className="topicLabel-container">
          <div className="topic-label skeleton-label">
            <div className="skeleton-icon"></div>
            <div className="skeleton-label-text"></div>
          </div>
        </div>
        <div className="d-flex gap-2 align-items-center justify-content-end mt-3">
          <div className="topic-content">
            <div className="skeleton-topic-name"></div>
            <div className="topic-question">
              <div className="skeleton-question-icon"></div>
              <div className="skeleton-question-text"></div>
            </div>
          </div>
          <div className="skeleton-course-img"></div>
        </div>
      </div>
    </div>
  );

  // Generate skeleton items
  const generateSkeletons = (count = 8) => {
    return Array.from({ length: count }, (_, index) => (
      <TopicSkeleton key={`skeleton-${index}`} />
    ));
  };

  // Empty State Component
  const EmptyState = () => (
    <div className="topics-empty-state">
      <div className="empty-state-content">
        <div className="empty-state-icon">📚</div>
        <p className="empty-state-message">
          No trending topics available at the moment.
        </p>
        <button 
          className="retry-btn"
          onClick={getAllTrendingTopics}
        >
          Try Again
        </button>
      </div>
    </div>
  );

  return (
    <div className="topics-container">
      <div className="container topic-head-section pt-3 pb-3">
        <div>
          <div className="topic-head">
            Trending Topics
            {isLoading && (
              <Loader2 className="topic-loading-spinner" size={20} />
            )}
          </div>
          <div className="topic-sub-head">
            Dive into our extensive collection of MCQs, meticulously crafted to
            reinforce your understanding of key concepts.
          </div>
        </div>

        <button 
          onClick={() => window.location.href = 'https://app.edraakonline.com/courselist'} 
          className="topic-allcourse-btn"
          disabled={isLoading}
          style={{ opacity: isLoading ? 0.7 : 1 }}
        >
          All courses
        </button>
      </div>

      {isLoading ? (
        // Show skeleton loading in scroll wrapper
        <div 
          className="scroll-wrapper" 
          onMouseEnter={() => setPaused(true)} 
          onMouseLeave={() => setPaused(false)}
        >
          <div 
            className="topiclist" 
            style={{ animationPlayState: "paused" }}
          >
            {generateSkeletons(8)}
          </div>
        </div>
      ) : topicList.length === 0 ? (
        // Show empty state outside scroll wrapper
        <div className="topics-empty-wrapper">
          <EmptyState />
        </div>
      ) : (
        // Show actual content in scroll wrapper
        <div 
          className="scroll-wrapper" 
          onMouseEnter={() => setPaused(true)} 
          onMouseLeave={() => setPaused(false)}
        >
          <div 
            className="topiclist" 
            style={{ animationPlayState: paused ? "paused" : "running" }}
          >
            {fullList?.map((topic, index) => (
              <div key={`${topic._id || topic.id}-${index}`} className="topic-item">
                <div>
                  <div className="topicLabel-container">
                    {!topic?.is_trending ? (
                      <div className="topic-label">
                        <Sparkles size={16} color="#ebd700" /> New course
                      </div>
                    ) : (
                      <div className="topic-label">
                        <Zap size={16} color="#ebd700" />Trending Now
                      </div>
                    )}
                  </div>
                  <div className="d-flex gap-2 align-items-center justify-content-end mt-3">
                    <div className="topic-content">
                      <div className="topic-name">{topic.topic_name || "Untitled Topic"}</div>
                      <div className="topic-question">
                        <img
                          src="/assets/img/question.png"
                          alt="book-icon"
                          className="topic-question-icon"
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                        {topic.total_question || 0} Questions
                      </div>
                    </div>
                    <img
                      src={
                        topic?.image
                          ? apiConstants.imgUrl + topic?.image
                          : 'https://i.postimg.cc/VvQp3Y88/illustration-of-book-icon-free-vector.jpg'
                      }
                      className="topicCourse_img"
                      alt="Course-Image"
                      onError={(e) => {
                        e.target.src = 'https://i.postimg.cc/9f6rgsyX/course-dummy.png';
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Gradient Overlays */}
          <div className="gradient-left"></div>
          <div className="gradient-right"></div>
        </div>
      )}
    </div>
  );
};

export default TredingTopics;